import React, { Component } from 'react'
import ReactDOM from 'react-dom'

class Rotate extends Component {
  constructor(props) {
		super(props)

		this.state = {
      isRotating: false
		}
	}

  componentDidMount() {
    window.addEventListener('mousemove', this.handleMouseMove)
    window.addEventListener('mouseup', this.handleMouseUp)
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('mouseup', this.handleMouseUp)
  }

  handleMouseMove = () => {
    if (this.state.isRotating) {
      const rotation = this.calculateDegrees(this.getRelativeCoordinates(event))
      this.onRotating({degrees: rotation.degrees, radians: rotation.radians})
    }
  }

  handleMouseUp = () => {
    const { isRotating } = this.state

    if (isRotating) this.setState({isRotating: false}, () => {
      this.props.editRiderStageplanItem()
      this.props.onRotateEnd()
    })
  }

  getRelativeCoordinates(event) {
    const clientRect = ReactDOM.findDOMNode(this).getBoundingClientRect()

    return {
      mousex: event.clientX - clientRect.left - (clientRect.width/2),
      mousey: event.clientY - clientRect.top - (clientRect.height/2)
    }
  }

  calculateDegrees(coordinates) {
    const radians = Math.atan2(coordinates.mousex, coordinates.mousey)
    const degrees = (radians * (180 / Math.PI) * -1)

    return {degrees, radians}
  }

  onRotating = (rotation) => {
    this.props.onRotate(rotation)
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="rotate-handle" onMouseDown={(e) => this.setState({isRotating: true}, this.props.onRotateStart())} />
      </div>
    )
  }
}

export default Rotate



// WEBPACK FOOTER //
// ./src/components/rider/rider-stageplans/rotate.js